import React from 'react';
import { IconMenu, MenuItem, IconButton } from 'material-ui';
import R, { equals } from 'ramda';
import { getStatusColor, getStatusIcon } from '../../contractingUtils';

const ChangeStatusMenuForContractor = ({ state, shownStatus, changeContractStateTo, locationId, files }) => {
  return (
    <IconMenu
      autoWidth={false}
      iconButtonElement={
        <IconButton
          iconClassName="tc-icon-arrow-drop-down"
          iconStyle={{ color: '#616061' }}
        />
      }
      anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
      targetOrigin={{ horizontal: 'right', vertical: 'top' }}
      menuStyle={{ overflow: 'hidden' }}
    >
      {
        shownStatus !== 'sent' && !locationId ?
          <MenuItem
            onTouchTap={() => changeContractStateTo('sent')}
            innerDivStyle={{ color: getStatusColor('sent'), left: '-8px' }}
            disabled={shownStatus === 'sent'}
            leftIcon={
              <IconButton
                iconClassName={getStatusIcon('sent')}
                iconStyle={{ color: getStatusColor('sent'), top: '-14px' }}
              />
            }
            primaryText={'sent'}
          /> : <div/>
      }
      <MenuItem
        onTouchTap={() => changeContractStateTo('received')}
        disabled={shownStatus === 'received'}
        innerDivStyle={{ color: getStatusColor('rates received'), left: '-8px' }}
        leftIcon={
          <IconButton
            iconClassName={getStatusIcon('rates received')}
            iconStyle={{ color: getStatusColor('rates received'), top: '-14px' }}
          />
        }
        primaryText={'rates received'}
      />
      {
        // shownStatus === 'sent' && !locationId ?
        //   <MenuItem
        //     onTouchTap={() => changeContractStateTo('received externally')}
        //     innerDivStyle={{ color: getStatusColor('received externally'), left: '-8px' }}
        //     leftIcon={
        //       <IconButton
        //         iconClassName={getStatusIcon('received externally')}
        //         iconStyle={{ color: getStatusColor('received externally'), top: '-14px' }}
        //       />
        //     }
        //     primaryText={'received externally'}
        //   /> : <div/>
      }
      <MenuItem
        disabled={equals(state, 'accepted')}
        onTouchTap={() => changeContractStateTo('accepted')}
        innerDivStyle={{ color: getStatusColor('accepted'), left: '-8px' }}
        leftIcon={
            <IconButton
              iconClassName={getStatusIcon('accepted')}
              iconStyle={{ color: equals(state, 'accepted') ? 'grey' : getStatusColor('accepted'), top: '-14px' }}
            />
          }
        primaryText={'accepted'}
      />
      <MenuItem
        disabled={equals(state, 'loading')}
        onTouchTap={() => changeContractStateTo('loading')}
        innerDivStyle={{ color: getStatusColor('loading'), left: '-8px' }}
        leftIcon={
          <IconButton
            iconClassName={getStatusIcon('loading')}
            iconStyle={{ color: equals(state, 'loading') ? 'grey' : getStatusColor('loading'), top: '-14px' }}
          />
        }
        primaryText={'loading'}
      />
      <MenuItem
        disabled={equals(state, 'loaded')}
        onTouchTap={() => changeContractStateTo('loaded')}
        innerDivStyle={{ color: getStatusColor('loaded'), left: '-8px' }}
        leftIcon={
            <IconButton
              iconClassName={getStatusIcon('loaded')}
              iconStyle={{ color: equals(state, 'loaded') ? 'grey' : getStatusColor('loaded'), top: '-14px' }}
            />
          }
        primaryText={'loaded'}
      />
      <MenuItem
        disabled={equals(state, 'rejected')}
        onTouchTap={() => changeContractStateTo('rejected')}
        innerDivStyle={{ color: getStatusColor('rejected'), left: '-8px' }}
        leftIcon={
            <IconButton
              iconClassName={getStatusIcon('rejected')}
              iconStyle={{ color: equals(state, 'rejected') ? 'grey' : getStatusColor('rejected'), top: '-14px' }}
            />
          }
        primaryText={'rejected'}
      />
    </IconMenu>
  );
};

export default ChangeStatusMenuForContractor;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/left-nav/change-status-menu-Contractor.jsx